import React, { Component, Fragment } from 'react';
import { flowStr } from './utils'
import AttackInfoPanel from './AttackInfoPanel'
export default class MotEntryDetail extends Component {

  render(){
    var {selectedMot,selectedMotId} = this.props;
    if(!selectedMot) return <div>Loading...</div>
    return <div>
      <table className="compactTable u-full-width">
        <tbody>
          <tr><th colSpan="4" className="alt">State Info</th></tr>
          <tr><th colSpan={2}>Index</th><td colSpan={2}>#{selectedMotId.toString(16)}</td></tr>
          <tr><th colSpan={2}>Name</th><td colSpan={2}>{selectedMot.name}</td></tr>
          <tr><th colSpan={2}>Anim</th><td colSpan={2}>{selectedMot.anim}</td></tr>
          <tr><th colSpan={2}>Vuln</th><td colSpan={2}>{selectedMot.vulFlags.toString()}</td></tr>
          <AttackInfoPanel {...this.props} startIndex={0} />
        </tbody>
      </table>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/MotEntryDetail.js